export default __webpack_public_path__ + "static/media/jose--desktop.95445fd5.jpg";